import AnalyticsUtil from '../../../../utils/AnalyticsUtil';

class MAXBannerAnalytics {
	static analyticsUtil = new AnalyticsUtil();
	static ingest = MAXBannerAnalytics.analyticsUtil.ingest;

	static postRender(): void {
		this.analyticsUtil.logAnalytics({
			setEventSubcategory: 'MAX Banner',
			setEventSubtype: 'banner',
			setEventType: 'render',
			setEventWorkFlow: 'Home',
		});
		this.analyticsUtil.sendToIngest(this.ingest, true);
	}

	static postClick(setEventSubtype: string): void {
		this.analyticsUtil.logAnalytics({
			setEventSubcategory: 'MAX Banner',
			setEventSubtype,
			setEventType: 'click',
			setEventWorkFlow: 'Home',
		});
		this.analyticsUtil.sendToIngest(this.ingest, true);
	}
}

export default MAXBannerAnalytics;
